export interface ICountData {
    completedCounts: number;
    totalCounts: number;
}

export interface IInstruemntStatus {
    id: string;
    name: string;
}

export interface ISampleInstrumentDetails {
    count: ICountData;
    id: string;
    instrumentStatus: IInstruemntStatus;
    name: string;
}

export class SampleInstrumentDetails implements ISampleInstrumentDetails {
    count: ICountData;
    id: string;
    instrumentStatus: IInstruemntStatus;
    name: string;

    constructor(count: ICountData,
        id: string,
        instrumentStatus: IInstruemntStatus,
        name: string) {

        this.count = count;
        this.id = id;
        this.instrumentStatus = instrumentStatus;
        this.name = name;
    }
}

const defaultSampleInstrumentDetails = new SampleInstrumentDetails({ totalCounts: 0, completedCounts: 0 }, "", { id: "", name: "" }, "");
export { defaultSampleInstrumentDetails };